export default __webpack_public_path__ + "static/image2-edit-rooms-002211ff730e68a938980e340ba231ff.png";